import {
  Box,
  Button,
  Paper,
  OutlinedInput,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  FormControl,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({}));

export default function FaqManagement() {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  /* Accordion */
  const [expanded, setExpanded] = useState();
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <main id="main" className="container">
      <Tabs
        value={value}
        onChange={handleChangeTabs}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="전체" />
        <Tab label="회원" />
        <Tab label="포인트" />
        <Tab label="혜택" />
        <Tab label="매장이용" />
        <Tab label="Item Six" />
        <Tab label="Item Seven" />
      </Tabs>

      {/* ST : search-box */}
      <Box className="search-box-wrap">
        <FormControl variant="outlined">
          <OutlinedInput
            placeholder="궁금하신 내용을 검색해주세요"
            type="search"
            className="search-box"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  type="submit"
                  aria-label="search"
                  className="btn-search"
                  edge="end"
                >
                  <span className="hidden">search</span>
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Box>
      {/* EN : search-box */}

      {/* ST : board-list accordion */}
      <div className="board-list board-list-faq">
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          className="item"
        >
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <p>구입한 물건을 교환 또는 환불하려고 하는데 어떻게 해야하나요?</p>
          </AccordionSummary>
          <AccordionDetails>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          className="item"
        >
          <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
            <p>메가포인트 적립 및 사용은 어떻게 하나요?</p>
          </AccordionSummary>
          <AccordionDetails>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </p>
          </AccordionDetails>
        </Accordion>
      </div>
      {/* EN : board-list accordion */}
    </main>
  );
}
